<template>
    <div class="home">
        <b-container fluid>
            <h1 class="mb-5">{{$keycloak.fullName}}'s Dashboard</h1>

            <div v-if="$keycloak.authenticated && ($keycloak.hasResourceRole('provider-admin'))">
                <b-button href="/provider/users" variant="primary">Go to authorized users</b-button>
              <hr/>
            </div>

            <div v-if="$keycloak.authenticated && ($keycloak.hasResourceRole('provider') || $keycloak.hasResourceRole('provider-admin'))">
              <div>
                <h1>Currently verified and employed CNAs</h1>
              </div>
                <div>
                    <h2>Active on registry:</h2>
                    <ProviderCNATableList :items="activeCnas" slug="cnas" @showStatusModal="showStatusModal"/>
                </div>
              <div>
                <h2>Inactive on registry:</h2>
                <p>
                  Nurse Aides with an inactive registry status cannot work as a nurse aide in nursing homes or certified boarding care homes until their status is active. Unless the individual can prove that he or she has recently successfully completed a training and competency evaluation program approved by the State and has not yet been included in the registry. Facilities must follow up to ensure that such an individual actually becomes registered (<a href="https://www.ecfr.gov/current/title-42/part-483/section-483.35#p-483.35(d)(4)(ii)">42 CFR 483.35(d)(4)(ii)</a>). Please communicate directly with the nurse aide to resolve and/or how to update their status. Resources can be found on the <a href="https://www.health.state.mn.us/facilities/providers/nursingassistant/index.html">Nurse Aide Registry website</a>.
                </p>
                  <ProviderCNATableList :items="inactiveCnas" slug="inactiveCNAs" @showStatusModal="showStatusModal"/>
              </div>
              <div>
                <b-button variant="primary" class="m-2" @click="showAddModal">Add CNA</b-button>
              </div>
              <div>
                <b-button variant="primary" class="m-2" @click="viewHistoricalCNAs=!viewHistoricalCNAs">{{viewHistoricalCNAs?'Hide':'View'}} previously employed CNAs</b-button>
              </div>
              <div v-if="viewHistoricalCNAs">
                <h1>Previously employed CNAs</h1>
                <div>
                  <h2>Active on registry:</h2>
                  <ProviderCNATableList :items="oldActiveCnas" @showStatusModal="showStatusModal"/>
                </div>
                <div>
                  <h2>Inactive on registry:</h2>
                  <ProviderCNATableList :items="oldInactiveCnas" @showStatusModal="showStatusModal"/>
                </div>
              </div>

                <div>
                    <b-button variant="primary" class="m-2" @click="showSemiannualModal">Submit Facility Nursing Aide Staff Report</b-button>
                    <b-button variant="secondary" class="m-2" @click="openSemiannuals">View Facility Nursing Aide Staff Reports</b-button>
                </div>
<!--                <div>-->
<!--                    <h2>Self-reported CNAs</h2>-->
<!--                    <p>These are the CNAs that self-reported having worked at your facility which you haven't verified yet.</p>-->
<!--                    <ProviderCNATableList :items="pendingCnas" slug="pendingCnas" @showVerifyModal="showVerifyModal"/>-->
<!--                </div>-->
<!--              <div>-->
<!--              <b-button variant="secondary" class="m-2" @click="viewRejected=!viewRejected">{{viewRejected?'Hide':'View'}} rejected CNAs</b-button>-->
<!--              </div>-->
<!--              <div v-if="viewRejected">-->
<!--                <h2>Rejected CNAs:</h2>-->
<!--                <p>These are the CNAs that self-reported as working at your facility and were subsequently rejected by you.</p>-->
<!--                <ProviderCNATableList :items="rejectedCnas"/>-->
<!--              </div>-->


            </div>

            <div v-if="$keycloak.authenticated && ($keycloak.hasResourceRole('cna'))">
                <div v-if="certificate != null">
                    <b-row >
                        <b-col cols="12">
                            <h2 class="green-header">Your Certificate Information</h2>
                            <Dashboard :certificate="certificate"></Dashboard>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <b-row class="mt-4 mb-4" v-if="$keycloak.authenticated && $keycloak.hasResourceRole('readonly')">
                <b-col>
                    Welcome to the Minnesota Nurse Aide Registry.
                    Please use the 'Search' link above to locate specific certificate details.
                </b-col>
            </b-row>

            <div v-if="$keycloak.authenticated && ($keycloak.hasResourceRole('mdh-admin') || $keycloak.hasResourceRole('mnit-admin')
            || $keycloak.hasResourceRole('mdh-staff') || $keycloak.hasResourceRole('readonly'))" class="mt-2">
                <b-row>
                    <b-col>
                        <b-form-checkbox v-model="assignedOnly" name="assigned-input" switch @change="loadPendingApplications($event)">
                            Show My Assigned Applications Only
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h2 class="green-header">Pending Applications</h2>
                        <AdminTableList slug="pendingApplications" :items="pendingApplications"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h2 class="green-header">Pending Interstate Endorsements</h2>
                        <AdminInterstateTableList slug="pendingInterstate" :items="pendingInterstate"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h2 class="green-header">Pending Headmaster Applications</h2>
                        <AdminTableList slug="pendingHeadmaster" :items="pendingHeadmaster"/>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h2 class="green-header">Secondary Review Applications</h2>
                    <AdminTableList slug="secondaryReviewApplications" :items="secondaryReview"/>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h2 class="green-header">Applications With Unread Notes from Applicants</h2>
                        <AdminTableList slug="unreadApplications" :items="unread"/>
                    </b-col>
                </b-row>
            </div>
            <div v-if="$keycloak.authenticated && ($keycloak.hasResourceRole('cna') || $keycloak.hasResourceRole('interstate'))" class="mt-2">
              <b-row v-if="$keycloak.hasResourceRole('interstate') && !$keycloak.hasResourceRole('cna') && !userApplications.find(x=>x.status!=='DENIED')">
                <b-col>
                    <b-button variant="primary" class="mt-2" href="/register/endorsement">Submit Interstate Application</b-button>
                    <span>&nbsp;</span>
                    <b-button variant="primary" class="mt-2" href="/register/cna">I tested out in Minnesota</b-button>
                </b-col>
              </b-row>
              <b-row>
                  <b-col>
                    <h2 class="green-header">Your Applications</h2>
                    <ApplicantTableList slug="userApplications" :items="userApplications"/>
                </b-col>
                </b-row>
            </div>
        </b-container>

        <b-modal id="provider-cna-status-modal" hide-header hide-footer>
            <h2>Change Status</h2>
            <ProviderCNAStatusUpdate :currentCna="currentCna"
                                     :statusOptions="statusOptions.filter(x=>x.value!=='NWH')"
                                     @hideStatusModal="hideStatusModal"
                                     @success="handleStatusUpdate"
                                     @failure="showRootToast('CNA status update failure','CNA\'s status has failed to update','danger')"
            />
        </b-modal>
        <b-modal id="provider-cna-verify-modal" hide-header hide-footer>
            <h2>Verify CNA</h2>
            <ProviderCNAVerification :currentCna="currentCna"
                                     :statusOptions="statusOptions"
                                     @hideVerifyModal="hideVerifyModal"
                                     @success="handleVerificationUpdate"
                                     @failure="showRootToast('CNA verification failure', 'CNA\'s verification failed to update', 'danger')"/>
        </b-modal>

        <b-modal id="provider-cna-add-modal" hide-header hide-footer no-close-on-backdrop>
            <h2>Add CNA</h2>
            <ProviderCNAAdd :statusOptions="statusOptions.filter(x=>x.value!=='NWH')"
                            @hideAddModal="hideAddModal"
                            @success="handleAddUpdate"
                            @failure="showRootToast('CNA add failure', 'CNA failed to add', 'danger')"
            />
        </b-modal>
        <b-modal id="provider-semiannual-modal" hide-header hide-footer>
            <h2>Submit Provider Nurse Aide Staff Report</h2>
          <div>Click <strong>submit</strong> to affirm that the <strong>Verified and Active CNAs list</strong> is correct to the best of your knowledge and submit your report to MDH. Click <strong>Cancel</strong> to exit.</div>
            <div>
                <b-button variant="primary" class="m-2" @click="submitSemiannual">Submit</b-button>
                <b-button variant="secondary" class="m-2" @click="hideSemiannualModal">Cancel</b-button>
            </div>
          <div class="text-danger" v-if="showSubmissionError">In order to avoid too frequent expiration date updates and to avoid accidental updates of NAs who are no longer employed at this organization we require a last worked date for each listed current NA.</div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import Dashboard from "./cna-user/Dashboard";
import AdminTableList from "@/components/templates/AdminTableList";
import AdminInterstateTableList from "@/components/templates/AdminInterstateTableList";
import ApplicantTableList from "@/components/templates/ApplicantTableList";
import ProviderCNATableList from "@/components/templates/ProviderCNATableList";
import ProviderCNAStatusUpdate from "./provider/ProviderCNAStatusUpdate";
import ProviderCNAVerification from "./provider/ProviderCNAVerification";
import ProviderCNAAdd from "./provider/ProviderCNAAdd";



export default {
  components: {
      Dashboard,
      AdminTableList,
      AdminInterstateTableList,
      ApplicantTableList,
      ProviderCNATableList,
      ProviderCNAStatusUpdate,
      ProviderCNAVerification,
      ProviderCNAAdd,
  },
  data: () => ({
      certificate: null,
      pendingApplications: [],
      pendingHeadmaster: [],
      pendingInterstate: [],
      userApplications: [],
      activeCnas: [],
      inactiveCnas: [],
      oldActiveCnas: [],
      oldInactiveCnas: [],
      pendingCnas: [],
      rejectedCnas: [],
      currentCna: null,
      statusOptions: [],
      pendingSemiannuals: [],
      assignedOnly: false,
      secondaryReview: [],
      unread: [],
      viewHistoricalCNAs: false,
      viewRejected: false,
      showSubmissionError: false,
  }),
  
  computed: {
    userRole() {
      return this.$store.state.userRole
    },
  },

  mounted() {
    if (this.$keycloak) {
        if (this.hasRole('cna')) {
            this.loadCertificate()
            this.loadUserApplications()
        }
        if(this.hasRole('mdh-admin') || this.hasRole('mdh-staff') || this.hasRole('readonly') || this.hasRole('mnit-admin')){
            this.loadPendingApplications()
            this.loadSecondaryReviewApplications()
            this.loadUnreadApplications()
        }
        if(this.hasRole('interstate')){
            this.loadUserApplications();
        }
        if(this.hasRole('provider') || this.hasRole('provider-admin')){
            this.loadFacilityCNAs();
            this.loadStatusOptions();
        }
    }
  },

  methods: {
      loadCertificate() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/certificate/user`)
          .then(response => {
              this.certificate = response.data
          })
      },
      hasRole(roles) {
          if (this.$keycloak) {
              return this.$keycloak.hasResourceRole(roles)
          } else {
              return false;
          }
      },
      loadPendingApplications(assignedOnly){
          if (assignedOnly === undefined) {
              assignedOnly = false
          }
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/pending/${assignedOnly}`)
              .then(response =>{
                  this.pendingApplications = response.data;
              })
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/pending-interstate/${assignedOnly}`)
              .then(response =>{
                  this.pendingInterstate = response.data;
              })
      },
      loadSecondaryReviewApplications(){
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/secondaryReview`)
            .then(response => {
              this.secondaryReview = response.data;
            })
      },
      loadUnreadApplications(){
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/unread`)
              .then(response => {
                  this.unread = response.data;
              })
      },
      loadUserApplications(){
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/allByUser`)
              .then(response => {
                  this.userApplications = response.data.sort((a1, a2)=>{
                    if(a1.status==='Draft'){
                      return -1;
                    }
                    else if(a2.status==='Draft'){
                      return 1;
                    }
                    if(a1.submittedDate > a2.submittedDate){
                      return -1;
                    }
                    else if(a2.submittedDate > a1.submittedDate){
                      return 1;
                    }
                    return 0;
                  });
              })
      },
      loadFacilityCNAs(){
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/provider/cna/get`)
              .then(response => {
                  this.activeCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus !=null && c.certificateStatus.description === 'Active' && c.status.code === 'CUR'));
                  this.inactiveCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus == null || c.certificateStatus.description === 'Inactive' && c.status.code === 'CUR'));
                  this.pendingCnas = response.data.filter(c=>c.verified.code==='PENDING');
                  this.oldActiveCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus !=null && c.certificateStatus.description === 'Active' && c.status.code !== 'CUR'));
                  this.oldInactiveCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus !=null && c.certificateStatus.description === 'Inactive' && c.status.code !== 'CUR'));
                  this.rejectedCnas = response.data.filter(c=>c.verified.code==='REJECTED');
              })

      },
      loadStatusOptions(){
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/provider/cna/options`)
              .then(response=>{
                  for(let status of response.data){
                      this.statusOptions.push({
                          value: status.code,
                          text: status.description
                      })
                  }
              })
      },
      showStatusModal(item){
          this.currentCna = Object.assign({},item);
          this.currentCna.status = this.currentCna.status.code;
          this.$bvModal.show('provider-cna-status-modal');
      },
      showAddModal(){
          this.$bvModal.show('provider-cna-add-modal');
      },
      hideAddModal(){
          this.$bvModal.hide('provider-cna-add-modal');
      },
      hideStatusModal(){
          this.$bvModal.hide('provider-cna-status-modal');
      },
      showVerifyModal(item){
          this.currentCna = Object.assign({},item);
          this.currentCna.status = this.currentCna.status.code;
          this.$bvModal.show('provider-cna-verify-modal');
      },
      hideVerifyModal(){
          this.$bvModal.hide('provider-cna-verify-modal');
      },
      showRootToast(title, message, type) {
          this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              noAutoHide:true
          })
          this.toastFocus()
      },
      toastFocus() {
          setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length-1]
              elem.focus()
          }, 100)
      },
      handleStatusUpdate(){
          this.showRootToast('CNA status updated','CNA\'s status has been successfully updated','success');
          this.loadFacilityCNAs();
      },
      handleVerificationUpdate(verify){
          this.showRootToast('CNA verification updated', 'CNA has been successfully '+(verify?'verified':'rejected'),'success');
          this.loadFacilityCNAs();
      },
      handleAddUpdate(){
          this.showRootToast('CNA added', 'CNA has been successfully added','success');
          this.loadFacilityCNAs();
      },
      showSemiannualModal(){
          this.$bvModal.show('provider-semiannual-modal');
     },
      hideSemiannualModal(){
          this.$bvModal.hide('provider-semiannual-modal');
      },
      submitSemiannual(){
        this.showSubmissionError = false;
        let currentNAsWithNoLastWorkedDate = this.activeCnas.filter(cna=>cna.lastWorkedDate==null);
        if(currentNAsWithNoLastWorkedDate.length > 0){
          this.showSubmissionError = true;
          return;
        }
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/semiannual/provider/submit`)
              .then(response=>{
                  this.showRootToast('Report submitted', 'Facility Nurse Aide Staff Report has been successfully submitted to MDH','success');
              }).catch(error=>{
                  this.showRootToast('Facility Nurse Aide Staff Report submit failed', 'Facility Nurse Aide Staff Report has failed to submit','danger');
          }).finally(()=>{
            this.hideSemiannualModal();
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/provider/cna/get`)
                .then(response => {
                  this.activeCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus !=null && c.certificateStatus.description === 'Active' && c.status.code === 'CUR'));
                  this.inactiveCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus == null || c.certificateStatus.description === 'Inactive' && c.status.code === 'CUR'));
                  this.pendingCnas = response.data.filter(c=>c.verified.code==='PENDING');
                  this.oldActiveCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus !=null && c.certificateStatus.description === 'Active' && c.status.code !== 'CUR'));
                  this.oldInactiveCnas = response.data.filter(c=>c.verified.code==='VERIFIED' && (c.certificateStatus !=null && c.certificateStatus.description === 'Inactive' && c.status.code !== 'CUR'));
                  this.rejectedCnas = response.data.filter(c=>c.verified.code==='REJECTED');
                })
          })
      },
      openSemiannuals(){
          this.$router.push({path: "/FacilityNAReports"})
      },
      hasPendingApplication(){
          return this.certificate.renewalStatus === 'Received' || this.certificate.renewalStatus === 'Reopened' || this.certificate.renewalStatus === 'Resubmitted';
      }
  },
  created() {
    document.title = "Dashboard - NAR"
  },
}
</script>

<style>
 .green-header {
     color: #60A609;
 }
</style>